import { atom, selector } from 'recoil';
export var modal = atom({
    key: 'modal',
    default: 'import'
});
export var view = atom({ key: 'view', default: 'basemap' });
export var isPreloadingGraph = atom({
    key: 'preloadingGraph',
    default: false
});
/**
 * Graph atoms.
 */
export var graph = atom({
    key: 'graph',
    default: null,
    dangerouslyAllowMutability: true
});
export var renderer = atom({
    key: 'renderer',
    default: null,
    dangerouslyAllowMutability: true
});
export var model = atom({
    key: 'model',
    default: null
});
export var collaterals = atom({
    key: 'collaterals',
    default: null,
    dangerouslyAllowMutability: true
});
export var toolBoxState = atom({
    key: 'toolBoxState',
    default: null
});
export var graphVariables = selector({
    key: 'graphSelector',
    get: function (_a) {
        var get = _a.get;
        var state = get(toolBoxState);
        var currentModel = get(model);
        if (!state || !currentModel)
            return null;
        return {
            nodeColor: state.variables.nodes.color
                ? currentModel.nodes[state.variables.nodes.color]
                : null,
            nodeSize: state.variables.nodes.size
                ? currentModel.nodes[state.variables.nodes.size]
                : null,
            nodeLabel: state.variables.labels.text
                ? currentModel.nodes[state.variables.labels.text]
                : null,
            labelDensity: state.variables.labels.density,
            edgeColor: state.variables.edges.color
                ? currentModel.edges[state.variables.edges.color]
                : null,
            edgeSize: state.variables.edges.size
                ? currentModel.edges[state.variables.edges.size]
                : null
        };
    }
});
